import SettingsModel from 'models/SettingsModel';

export default Backbone.Collection.extend({

    model: SettingsModel,

    /**
     * This method will add a setting to this collection
     *
     * @param {string} key under which to store this setting
     * @param {string} value to store under this key
     * @returns {SettingsModel} created model
     */
    addSetting(key, value) {

        this.url = '/users/settings_backend.json';

        var existingModel = this.findWhere({
            keyword: key
        });

        if (existingModel !== undefined) {
            existingModel.set({
                value
            });
            existingModel.save();

            return existingModel;
        }

        var newModel = new SettingsModel({
            keyword: key,
            value
        });

        this.create(newModel);
        return newModel;

    }
}, {
    type: 'settings'
});
